import { Text, Tooltip } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ProductActiveTraitTooltipProps {
  isDisabled?: boolean;
  label: string;
  children: ReactNode;
}

export function ProductActiveTraitTooltip({
  isDisabled = false,
  label,
  children,
}: ProductActiveTraitTooltipProps) {
  return (
    <Tooltip
      isDisabled={isDisabled}
      paddingY="2xs"
      paddingX="xs"
      maxWidth="300px"
      background="gray.50"
      borderRadius="xl"
      boxShadow="0px 0px 0px 1px rgba(0, 0, 0, 0.02), 0px 1px 4px 0px rgba(0, 0, 0, 0.06), 0px 6px 24px 0px rgba(0, 0, 0, 0.06)"
      aria-label={label}
      label={
        <Text size="body3" color="gray.600">
          {label}
        </Text>
      }
      placement="top"
    >
      {children}
    </Tooltip>
  );
}
